<script>
    import {getContext} from 'svelte';
    export let users;
    export let coach;
    export let _playersClone;
    let positionInfo = getContext('positionInfo');
    let rank_alias = getContext('rank_alias');
</script>

{#each Object.entries(users[+coach.user_position].players) as [pos, data]}
    {#if data && Object.keys(data).length == 0}
    <li class="item" data-position={[pos]}>
        <button type="button" class="team">
            <span class="position-txt">{positionInfo.position_simple[pos]}</span>
        </button>
    </li>
    {:else}
    <li class="item" data-tier={rank_alias[_playersClone[data.lane][data.index].rank]}>
        <button type="button" class="team">
            <span class="img"><img
                    src="//upload3.inven.co.kr/upload/{_playersClone[data.lane][data.index].image.small}"
                    alt="{positionInfo.position_kor[pos]} 포지션" width="68" height="69"></span>
            {#if data.point} 
            <span class="point">{data.point}</span>
            {/if}
            {#if (_playersClone[data.lane][data.index].name) }
            <span class="name">{_playersClone[data.lane][data.index].name}</span>
            {/if}
        </button>
    </li>   
    {/if}

{/each}